import { render, staticRenderFns } from "./LevelsView.vue?vue&type=template&id=60083c5c&scoped=true&"
import script from "./LevelsView.vue?vue&type=script&lang=ts&"
export * from "./LevelsView.vue?vue&type=script&lang=ts&"
import style0 from "./LevelsView.vue?vue&type=style&index=0&id=60083c5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60083c5c",
  null
  
)

export default component.exports